import { useQuery } from 'react-query';
import { getDashboard, getDashboardQuick } from './Dashboard.service';
import { DashboardQuickParams } from './Dashboard.types';
import { queryClient } from '@/Root';
import notificationError from '@/utils/functions/notificationError';

export function useDashboardData(params: DashboardQuickParams) {
  const cache = queryClient.getQueryData(['dashboard-data', { ...params }]);

  return useQuery(
    ['dashboard-data', { ...params }],
    () => getDashboard(params),
    {
      enabled: !cache,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useDashboardQuick(params: DashboardQuickParams) {
  const cache = queryClient.getQueryData(['dashboard/quick', { ...params }]);

  return useQuery(
    ['dashboard/quick', { ...params }],
    () => getDashboardQuick(params),
    {
      enabled: !cache,
      onError(error) {
        notificationError(error);
      },
    },
  );
}
